import { Helmet } from 'react-helmet';

/**
 * meta alanindaki title
 * */
export const Title = ({ children }) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title> {children} - TYS - İslam Ansiklopedisi</title>
    </Helmet>
  );
};

export default Title;
